import React from 'react';
import { sendMessage, updateHeaders } from './api';
import { getSession, storeSession } from './ulti';

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    // if (message.includes('hello')) {
    //   actions.handleHello();
    // }

    console.log('DEBUG >> user says:', message);

    /** @type {Promise<SendMessageResponse>} */
    const responsePromise = sendMessage(message);
    responsePromise
      .then((res) => {
        console.log('DEBUG >> send message response', res);
        actions.handleReceive();
      })
      .catch(err => {
        // TODO: Handle error appropriately
        console.log('DEBUG >> send message error', err);
      });

    // }
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions: {},
        });
      })}
    </div>
  );
};

export default MessageParser;

